
import React from "react";
import { Link } from "react-router-dom";

const RelatedResourcesSection: React.FC = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold mb-8">Related Resources</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link to="/blogs/ai-in-xdr-platforms" className="block bg-white p-6 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="font-bold text-lg mb-2">The Role of AI in Next-Gen XDR Platforms</h3>
              <p className="text-gray-600">Discover how artificial intelligence is revolutionizing extended detection and response platforms for better security outcomes.</p>
            </Link>
            <Link to="/blogs/ai-xdr-vs-traditional-tools" className="block bg-white p-6 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="font-bold text-lg mb-2">How AI-Based XDR Detects Threats Faster Than Traditional Tools</h3>
              <p className="text-gray-600">Learn the mechanisms behind AI-powered threat detection and why it outperforms legacy security solutions.</p>
            </Link>
            <Link to="/blogs/xdr-siem-soar-comparison" className="block bg-white p-6 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="font-bold text-lg mb-2">XDR vs SIEM vs SOAR: What's Right for Your Security Stack?</h3>
              <p className="text-gray-600">Compare leading security technologies to determine which solution best meets your organization's unique security requirements.</p>
            </Link>
            <Link to="/blogs/top-xdr-features" className="block bg-white p-6 rounded-lg border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
              <h3 className="font-bold text-lg mb-2">Top 10 Features to Look for in an AI-Based XDR Solution</h3>
              <p className="text-gray-600">Essential capabilities that define effective AI-driven extended detection and response platforms in today's threat landscape.</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RelatedResourcesSection;
